(() => {
  if (customElements.get("cart-items")) {
    return;
  }

  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[name="updates[]"]').forEach((el) => {
        el.addEventListener("change", this.updateQuantity.bind(this));
      });

      this.querySelectorAll("button[data-remove]").forEach((el) => {
        el.addEventListener("click", this.updateQuantity.bind(this));
      });
    }

    updateQuantity(e) {
      const target = e.target;
      const line = target.dataset.index;
      const quantity = target.value ? target.value : 0;

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, {
        ...this.fetchConfig(),
        ...{ body },
      })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.handleErrorMessage(parsedState.errors);
          if (parsedState.errors) {
            return;
          }

          this.getSectionsToRender().forEach((section) => {
            const HTML = new DOMParser()
              .parseFromString(
                parsedState.sections[`${section.section}`],
                "text/html"
              )
              .querySelector(section.id).innerHTML;
            const HTMLSection = document.querySelector(section.id);
            if (HTMLSection) {
              HTMLSection.innerHTML = HTML;
            }
          });
        });
    }

    getSectionsToRender() {
      return [
        {
          id: "#CartMain",
          section: "cart",
        },
        {
          id: "#CartDrawer",
          section: "cart-drawer",
        },
      ];
    }

    handleErrorMessage(errorMessage) {
      const errorElement = this.querySelector("[data-error]");
      errorElement.removeAttribute("hidden");
      errorElement.querySelector("[data-error-message]").textContent =
        errorMessage;
    }

    fetchConfig(type = "json") {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`,
        },
      };
    }
  }

  customElements.define("cart-items", CartItems);
})();
